<template>
  <div v-show="styles_loaded" :class="setbrandid" :style="new_style_variables">
    <HeaderConfim
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="false"
      :show_home="true"
      :show_languages="true"
      :basket_number="0"
      :logo_image="logo_image"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></HeaderConfim>

    <div class="page-bg" :style="set_style_variables">
      <div class="confirmation-banner-container">
        <template v-if="setbrandid === 'SV1'">
          <ConfirmationBanner
            :headline="getrans('Thank you!')"
            :subheadline="''"
            edit-label="Edit"
          >
          </ConfirmationBanner>
        </template>
        <template v-else-if="setbrandid === 'PB1'">
          <ConfirmationBanner
            :headline="getrans('Your booking was successful.')"
            :subheadline="''"
            edit-label="Edit"
          >
          </ConfirmationBanner>
        </template>
        <template v-else-if="setbrandid === 'ML1'">
          <ConfirmationBanner
            :headline="getrans('Your Car Parking Has Been Confirmed!')"
            :subheadline="''"
            edit-label="Edit"
          >
          </ConfirmationBanner>
        </template>
        <template v-else-if="setbrandid === 'PIT'">
          <ConfirmationBanner
            :headline="getrans('Thank you for your booking')"
            :subheadline="''"
            edit-label="Edit"
          >
          </ConfirmationBanner>
        </template>
        <template v-else>
          <ConfirmationBanner
            :headline="getrans('Success!')"
            :subheadline="''"
            edit-label="Edit"
          >
          </ConfirmationBanner>
        </template>
      </div>

      <div
        class="page-content page-content--fullwidth"
        v-if="is_guest == 'Y' && guesttomember == 'N' && createaccount == 'N'"
      >
        <div class="page-content__box">
          <div class="page-content__box--box-style" style="margin-bottom: 0">
            <template v-if="setbrandid === 'YHM' || setbrandid === 'SV1'">
              <h3 class="page-content__box-title">
                {{ getrans("You Have Checked Out as a Guest") }}
              </h3>
              <p style="font-size: 1.2em; color: #545454">
                {{
                  getrans(
                    "Make future bookings faster, view old bookings, and manage new ones by creating an account."
                  )
                }}
              </p>
              <p style="max-width: 120ch">
                <template v-if="setbrandid === 'SV1'">
                  <b>{{ getrans("Please note:") }}</b
                  >&nbsp;{{
                    getrans(
                      "As a guest, your booking history will be erased three months after your booking has expired. Make future bookings faster and manage your travels with Summit by creating an account. To learn more about how your data is collected and used, please review our"
                    )
                  }}&nbsp;<a target="_blank" :href="privacy_policy_link">{{
                    getrans("Privacy Policy")
                  }}</a
                  >.
                </template>
                <template v-else>
                  <b>{{ getrans("Please note:") }}</b
                  >&nbsp;{{
                    getrans(
                      "As a guest, your booking history will not be accessible three months after your booking has expired. To learn more about how your data is collected and used, please review our"
                    )
                  }}&nbsp;<a target="_blank" :href="privacy_policy_link">{{
                    getrans("Privacy Policy")
                  }}</a
                  >.
                </template>
              </p>
            </template>
            <template v-else>
              <h3 class="page-content__box-title">
                {{ getrans("Please note you have checked out as a guest.") }}
              </h3>
              <p style="font-size: 1.2em; color: #545454">
                {{
                  getrans(
                    "Make future bookings faster, view old bookings and manage new ones"
                  )
                }}
              </p>
              <p style="max-width: 120ch">
                <b>{{ getrans("Please note:") }}</b
                >&nbsp;{{
                  getrans(
                    "As a guest your booking history, personal data and booking information will not be accessible three months after your booking has expired. We take your data privacy very seriously, To learn more visit our"
                  )
                }}&nbsp;<a target="_blank" :href="privacy_policy_link">{{
                  getrans("Privacy Notice")
                }}</a
                >.
              </p>
            </template>

            <button
              style="width: auto; padding: 1rem 3rem"
              class="page-content__box-btn"
              @click="createaccountaction"
            >
              {{ getrans("Create Account") }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="page-content page-content--fullwidth"
        v-if="createaccount == 'Y'"
      >
        <div class="page-content__box">
          <div class="page-content__box--box-style" style="margin-bottom: 0">
            <h3 class="page-content__box-title">
              <template v-if="setbrandid === 'SV1'">
                {{ getrans("Cheers to a smoother booking experience!") }}
              </template>
              <template v-else>
                {{
                  getrans("Congratulations! Account creation was successful.")
                }}
              </template>
            </h3>

            <template v-if="setbrandid === 'SV1'"></template>
            <template v-else-if="setbrandid === 'PB1' || setbrandid === 'FMM'">
              <p style="font-size: 1.2em; color: #545454">
                {{
                  getrans(
                    "Now you can book faster, view old bookings and manage new ones."
                  )
                }}
              </p>
              <h3
                class="page-content__box-title underline"
                @click="gotoPagenewtab(my_account_link)"
              >
                {{ getrans("Get Started") }}
              </h3>
            </template>
            <template v-else>
              <p style="font-size: 1.2em; color: #545454">
                {{
                  getrans(
                    "Now you can book faster, view old bookings and manage new ones."
                  )
                }}
              </p>
              <h3
                class="page-content__box-title underline"
                @click="gotoPagenewtab(my_account_link + '?lang=' + lang)"
              >
                {{ getrans("Get Started") }}
              </h3>
            </template>

            <template v-if="setbrandid === 'SV1'">
              <div class="account-created-box">
                {{ getrans("Account created") }}
                <img
                  class="confirmation-image"
                  src="@/assets/images/confirmation_green.svg"
                  alt="user image"
                />
              </div>
            </template>
            <template v-else>
              <div class="account-created-box">
                <img
                  class="confirmation-image"
                  src="@/assets/images/confirmation_green.svg"
                  alt="user image"
                />
                {{ getrans("Account created") }}
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="page-content">
        <div class="page-content__box">
          <div
            class="page-content__box--box-style page-content__box--box-center"
          >
            <img
              class="confirmation-image"
              src="@/assets/images/confirmation.svg"
              alt="user image"
            />

            <span v-if="setbrandid === 'YHM'"
              ><b>{{ getrans("Thank you for your booking!") }}</b>
              <p>
                {{
                  getrans(
                    "You will receive a parking confirmation in your inbox which will contain your QR code along with access to your tickets and receipt."
                  )
                }}
              </p></span
            >
            <span v-else-if="setbrandid === 'SV1'"
              ><b>{{ getrans("Payment Confirmed!") }}</b>
              <p>
                {{
                  getrans(
                    "You will receive a parking confirmation in your inbox with your QR code ticket and receipt. Please check your spam folder, if needed."
                  )
                }}
              </p></span
            >
            <span v-if="setbrandid === 'RSW'"
              ><b>{{ getrans("Your Payment has been successful") }}</b>
              <p>
                {{
                  getrans(
                    "If you do not receive the confirmation email within a few minutes of booking, please check your Spam folder."
                  )
                }}
              </p></span
            >
            <span v-else
              ><b>{{ getrans("Your Payment has been successful") }}</b></span
            >
          </div>

          <div class="page-content__box--box-style" v-if="cartmessage">
            <h3 class="page-content__box-title">
              <template v-if="setbrandid === 'SV1'">
                {{ getrans("Payment Confirmed!") }}
              </template>
              <template v-else>
                {{ getrans("Your Payment has been successful") }}
              </template>
            </h3>
            <p>
              {{
                getrans(
                  "Your booking is currently in progress and we will email you as soon as the reservation is completed."
                )
              }}
            </p>
          </div>

          <div class="page-content__box" v-if="qr_data_names.length > 0">
            <div
              class="page-content__box--box-style"
              v-for="(item, i) in qr_data_names"
              :key="i"
            >
              <div class="tickets-bg-content">
                <h4 class="page-content__box-title">
                  {{ getrans(qr_product_name) }} {{ getrans("Ticket") }} -
                  {{ getrans(item) }}
                </h4>

                <div class="table-wrapper">
                  <div class="table-wrapper--with-qr">
                    <div class="table-wrap">
                      <table>
                        <tr>
                          <td class="td-left">
                            <b>{{ getrans("Product") }}</b
                            >:&nbsp;&nbsp;
                          </td>
                          <td class="td-left">
                            {{ getrans(qr_product_name) }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!-- break -->

                    <div class="table-wrap table-wrap-divider"></div>

                    <div class="table-wrap">
                      <table class="tickets-bg-content-mid">
                        <tr>
                          <td class="td-left">
                            <b>{{ getrans("Entry") }}</b
                            >:&nbsp;&nbsp;
                          </td>
                          <td class="td-left">
                            <i class="far fa-calendar-alt"></i>
                            {{ qr_date }} {{ qr_time }}
                          </td>
                        </tr>
                      </table>
                      <br />
                      <div
                        style="
                          display: flex;
                          width: 100%;
                          justify-content: center;
                        "
                      >
                        <a :href="qr_data_qrcodes[i]" download="image.jpg">
                          <img style="width: 120px" :src="qr_data_qrcodes[i]" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="page-content__box--box-style"
            v-if="qr_data_names.length > 0 && !ordercomplete"
          >
            <h3 class="page-content__box-title">
              <i class="fas fa-circle-notch fa-spin"></i>
              {{ getrans("Please wait...") }}<br />
            </h3>
            <span>{{
              getrans("We are fetching your order confirmation details.")
            }}</span>
          </div>

          <div class="page-content__box--box-style" v-if="cartloaded">
            <h3 class="page-content__box-title">
              <template v-if="setbrandid === 'SV1'">
                {{ getrans("Booking Summary") }}
              </template>
              <template v-else>
                {{ getrans("Your Booking Summary") }}
              </template>
            </h3>
            <div class="page-content__box-ref">
              <span>{{ getrans("Booking Reference") }}</span>
              <span
                ><b>{{ orderreference }}</b></span
              >
            </div>
            <div>
              <BasketItem
                v-if="this.cartitem !== undefined && this.showcart"
                :prop_parking_cartitem="cartitem"
                :item_price="parseFloat(cartitem.price).toFixed(2)"
                :tot_price="parseFloat(final_amount_paid).toFixed(2)"
                :item_title="cartitem.carpark_name"
                :item_start_date="formatDatedmy(cartitem.valid_from)"
                :item_start_time="cartitem.start_time"
                :item_end_date="formatDatedmy(cartitem.valid_till)"
                :item_end_time="cartitem.end_time"
                :prop_fasttrack_cartitem="fasttrack_cartitem"
                :prop_lounge_cartitem="lounge_cartitem"
                :lang="lang.toUpperCase()"
                :translations="translations"
                :brandSlug="setbrandid"
                :currency="currency"
                :final_amount_paid_tot="final_amount_paid_tot"
              />
              <BasketItem
                v-else
                :prop_fasttrack_cartitem="fasttrack_cartitem"
                :prop_lounge_cartitem="lounge_cartitem"
                :lang="lang.toUpperCase()"
                :translations="translations"
                :brandSlug="setbrandid"
                :currency="currency"
                :final_amount_paid_tot="final_amount_paid_tot"
              />
            </div>

            <div class="page-content__basket-total">
              <span
                v-if="setbrandid === 'RDU' || setbrandid === 'PV1'"
                class="page-content__box-title--total"
                ><b>{{ getrans("Amount Paid") }} :</b></span
              >
              <span v-else class="page-content__box-title--total">
                <b v-if="setbrandid === 'RDU' || setbrandid === 'PV1'"
                  >{{ getrans("Amount Paid") }} :</b
                >
                <b v-else>{{ getrans("Total") }} :</b>
              </span>
              <span class="page-content__box-title--price"
                ><b>
                  {{
                    currency_formatter(
                      parseFloat(final_amount_paid_tot).toFixed(2)
                    )
                  }}
                </b></span
              >
            </div>
          </div>

          <div class="page-content__box" v-if="!cartmessage">
            <div class="page-content__box--box-style" v-if="false">
              <!--<h3 class="page-content__box-title">Get your ticket</h3>

              <div
                :class="`page-content__download-box ${
                  false ? 'page-content__download-box--active' : ''
                }`"
              >
                <div class="page-content__download-body">
                  <h4>Send via a free SMS text</h4>
                  <p>Your booking details will be sent to 07234 567890</p>
                </div>
                <div class="page-content__checkbox">
                  <img
                    v-if="false"
                    class="checkbox-image"
                    src="@/assets/images/download_active.svg"
                    alt="user image"
                  />
                  <img
                    v-else
                    class="checkbox-image"
                    src="@/assets/images/download_inactive.svg"
                    alt="user image"
                  />
                </div>
              </div> 

              <div
                :class="`page-content__download-box ${
                  true ? 'page-content__download-box--active' : ''
                }`"
              >
                <div class="page-content__download-body">
                  <h4>Sent again via email</h4>
                  <p>
                    Your booking confirmation has just been resent to you via
                    email
                  </p>
                </div>
                <div class="page-content__checkbox">
                  <img
                    v-if="true"
                    class="checkbox-image"
                    src="@/assets/images/download_active.svg"
                    alt="user image"
                  />
                  <img
                    v-else
                    class="checkbox-image"
                    src="@/assets/images/download_inactive.svg"
                    alt="user image"
                  />
                </div>
              </div>-->

              <!-- <div
                :class="`page-content__download-box ${
                  false ? 'page-content__download-box--active' : ''
                }`"
              >
                <div class="page-content__download-body">
                  <h4>Download now</h4>
                  <p>
                    Your booking confirmation will begin to download Immediately
                  </p>
                </div>
                <div class="page-content__checkbox">
                  <img
                    v-if="false"
                    class="checkbox-image"
                    src="@/assets/images/download_active.svg"
                    alt="user image"
                  />
                  <img
                    v-else
                    class="checkbox-image"
                    src="@/assets/images/download_inactive.svg"
                    alt="user image"
                  />
                </div>
              </div>

              <div :class="`page-content__download-box ${true ? 'page-content__download-box--active' : ''}`">
                    <div class="page-content__download-body">
                      <h4>iCal Download</h4>
                      <p>Add a reminder to your calendar. iCal file will begin to download immediately</p>

                    </div>
                    <div class="page-content__checkbox">
                        <img
                          v-if="true"
                          class="checkbox-image"
                          src="@/assets/images/download_active.svg"
                          alt="user image"
                        />
                        <img
                          v-else
                          class="checkbox-image"
                          src="@/assets/images/download_inactive.svg"
                          alt="user image"
                        />

                    </div>
                  </div> -->
            </div>
          </div>
        </div>

        <div class="page-content__box">
          <h1 v-if="setbrandid === 'YHM' || setbrandid === 'SV1'">
            {{ getrans("Support and FAQ") }}
          </h1>
          <h1 v-else>{{ getrans("What happens next") }}</h1>

          <template v-if="setbrandid === 'RDU'">
            <div
              class="page-content__box--box-style page-content__box--box-style"
            >
              <div class="page-content__box-numbered">
                <div class="page-content__box-number-text">
                  <p>
                    {{
                      getrans(
                        "You will receive an email that includes a QR Code and confirmation of your reservation details. Please present the QR code for entry at the gate. If you do not receive an email and/or QR code, please call the Parking office at (919) 840-2140 or contact us via email at "
                      )
                    }}<a href="mailto:rduparking@rdu.com" target="_blank"
                      >rduparking@rdu.com</a
                    >.
                  </p>
                </div>
              </div>
            </div>
          </template>

          <div
            class="page-content__box--box-style page-content__box--box-style nqy-custom-box"
          >
            <div class="page-content__box-numbered">
              <div class="page-content__box-number">1</div>
              <div class="page-content__box-number-text">
                <template v-if="setbrandid === 'YHM' || setbrandid === 'SV1'">
                  <h3 class="page-content__box-title">
                    {{ getrans("Questions?") }}
                  </h3>
                  <p>
                    {{
                      getrans(
                        "Have a question about your parking reservation or navigating the Airport? "
                      )
                    }}
                  </p>
                  <p>
                    {{ getrans("Please review our FAQ.") }}
                  </p>
                  <button
                    class="page-content__box-btn"
                    @click="gotoPagenewtab(faqs_link)"
                  >
                    {{ getrans("Read FAQ") }}
                  </button>
                </template>
                <template v-else-if="setbrandid === 'JER'">
                  <h3 class="page-content__box-title">
                    {{
                      getrans(
                        "Keep an eye out for your booking confirmation email"
                      )
                    }}
                  </h3>
                  <p>
                    {{
                      getrans(
                        "You will receive an immediate email confirmation of your booking in your inbox. If you cannot locate it, please check your spam filter."
                      )
                    }}
                  </p>
                  <button
                    class="page-content__box-btn"
                    @click="gotoPagenewtab(faqs_link)"
                  >
                    {{ getrans("Read FAQs") }}
                  </button>
                </template>

                <template v-else-if="setbrandid === 'PB1'">
                  <h3 class="page-content__box-title">
                    {{ getrans("Read our FAQ") }}
                  </h3>
                  <p>
                    {{
                      getrans(
                        "For help and support with any of your pre-visit or post-visit queries, browse through our frequently asked questions."
                      )
                    }}
                  </p>
                  <button
                    class="page-content__box-btn"
                    @click="gotoPagenewtab(faqs_link)"
                  >
                    {{ getrans("Read FAQs") }}
                  </button>
                </template>

                <template v-else>
                  <h3 class="page-content__box-title">
                    {{ getrans("Read our FAQ") }}
                  </h3>
                  <p>
                    {{
                      getrans(
                        "For help and support with any of your pre-travel or after travel queries browse through our frequently asked questions."
                      )
                    }}
                  </p>
                  <button
                    class="page-content__box-btn"
                    @click="gotoPagenewtab(faqs_link)"
                  >
                    {{ getrans("Read FAQs") }}
                  </button>
                </template>
              </div>
            </div>
          </div>

          <div
            class="page-content__box--box-style page-content__box--box-style nqy-custom-box"
          >
            <div class="page-content__box-numbered">
              <div class="page-content__box-number">2</div>

              <!-- RDU -->
              <div
                v-if="setbrandid === 'RDU'"
                class="page-content__box-number-text"
              >
                <h3 class="page-content__box-title">
                  {{ getrans("Manage your booking") }}
                </h3>

                <p>
                  {{
                    getrans(
                      "You may login to your account and manage your booking. By doing this you can amend, upgrade, cancel* your booking."
                    )
                  }}
                </p>
                <p>{{ getrans("Important note:") }}</p>
                <p>
                  {{
                    getrans(
                      "You are unable to Amend/Cancel within 24 hours of your booking start time."
                    )
                  }}
                </p>

                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  {{ getrans("Manage Account") }}
                </button>
              </div>
              <!-- RDU -->

              <!-- HER -->
              <div
                v-else-if="setbrandid === 'HER'"
                class="page-content__box-number-text"
              >
                <h3 class="page-content__box-title">
                  {{ getrans("Manage your booking") }}
                </h3>

                <p>
                  {{
                    getrans(
                      "You may login to your account and manage your booking. By doing this you can amend, upgrade, cancel* your booking or change your VRN."
                    )
                  }}
                </p>
                <p>{{ getrans("Important note:") }}</p>
                <p>
                  {{
                    getrans(
                      "Amendments can be processed at least 12 hours before the start of your booking. For VRN change can be made at least 6 hours before your booking starts."
                    )
                  }}
                </p>

                <button
                  class="page-content__box-btn"
                  @click="
                    gotoPagenewtab(
                      'https://myaccount.hermesairports.com/' + '?lang=' + lang
                    )
                  "
                >
                  {{ getrans("Manage Account") }}
                </button>
              </div>
              <!-- HER -->

              <!-- NWI -->

              <div
                class="page-content__box-number-text"
                v-else-if="setbrandid === 'NWI' || setbrandid === 'PIT'"
              >
                <h3 class="page-content__box-title">Manage your booking</h3>
                <p>
                  You can login to your account and manage your booking at any
                  time. You can view your booking, pay your balance or your add
                  passport details.
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  Manage Account
                </button>
              </div>
              <!-- NWI -->

              <!-- YHM -->
              <div
                class="page-content__box-number-text"
                v-else-if="setbrandid === 'YHM'"
              >
                <h3 class="page-content__box-title">Manage Your Booking</h3>
                <p>
                  Manage your booking anytime by logging into your account. In
                  the 'Manage My Booking' section, you can view your bookings,
                  access your QR code and receipts, and make changes to your
                  reservation.
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  Manage Account
                </button>
              </div>

              <!-- YHM -->

              <!-- SV1 -->
              <div
                class="page-content__box-number-text"
                v-else-if="setbrandid === 'SV1'"
              >
                <h3 class="page-content__box-title">Manage Your Booking</h3>
                <p>
                  Manage your booking anytime by logging into your account. In
                  the 'Manage My Booking' section, you can view your bookings,
                  access your QR code and receipts, and make changes to your
                  reservation.
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  Manage Account
                </button>
              </div>

              <!-- SV1 -->
              <!-- JER -->

              <div
                class="page-content__box-number-text"
                v-else-if="setbrandid === 'JER'"
              >
                <h3 class="page-content__box-title">
                  {{ getrans("Manage your booking") }}
                </h3>
                <p>
                  {{
                    getrans(
                      "Want to see your booking? Need to change something or cancel all together? Log in and manage your booking at any time."
                    )
                  }}
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  {{ getrans("Log me in") }}
                </button>
              </div>

              <!-- Default -->

              <div
                class="page-content__box-number-text"
                v-else-if="setbrandid === 'PB1'"
              >
                <h3 class="page-content__box-title">
                  {{ getrans("Manage your booking") }}
                </h3>
                <p>
                  {{
                    getrans(
                      "You can login to your account and manage your booking at any time. You can view your booking, make changes and more"
                    )
                  }}
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  {{ getrans("To Account") }}
                </button>
              </div>

              <div class="page-content__box-number-text" v-else>
                <h3 class="page-content__box-title">
                  {{ getrans("Manage your booking") }}
                </h3>
                <p>
                  {{
                    getrans(
                      "You can login to your account and manage your booking at any time. You can view your booking, pay your balance or your add passport details."
                    )
                  }}
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link)"
                >
                  {{ getrans("Manage Account") }}
                </button>
              </div>
              <!-- Default -->
            </div>
          </div>

          <template
            v-if="setbrandid === 'YHM' || setbrandid === 'SV1'"
          ></template>
          <template v-else>
            <div
              class="page-content__box--box-style page-content__box--box-style nqy-custom-box"
            >
              <div class="page-content__box-numbered">
                <div class="page-content__box-number">3</div>
                <div class="page-content__box-number-text">
                  <h3 class="page-content__box-title">
                    {{ getrans("Did you forget something?") }}
                  </h3>
                  <p>{{ getrans("Make another purchase") }}</p>
                  <template v-if="setbrandid === 'FMM'">
                    <button
                      class="page-content__box-btn"
                      @click="gotoPage('https://www.memmingen-airport.com/arrival-departure/parking-at-the-airport/')"
                    >
                      {{ getrans("Continue Shopping") }}
                    </button>
                  </template>
                  <template v-else>
                    <button
                      class="page-content__box-btn"
                      @click="gotoPage('/index.html')"
                    >
                      <template
                        v-if="setbrandid === 'RDU' || setbrandid === 'PV1'"
                      >
                        {{ getrans("Make Another Booking") }}
                      </template>
                      <template v-else>
                        {{ getrans("Continue Shopping") }}
                      </template>
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <Footernwi
      v-if="setbrandid === 'NWI'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footernwi>
    <Footerpit
      v-if="setbrandid === 'PIT'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footerpit>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footer>
    <!-- <LoginModel /> -->
    <Cookies :brandSlug="setbrandid" :translations="translations"/>
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'RDU'" />
  </div>
</template>

<script>
const axios = require("axios");
import HeaderConfim from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import Footernwi from "../../components/FooterNWI.vue";
import ConfirmationBanner from "../../components/ConfirmationBanner.vue";
import BasketItem from "../../components/BasketItem_confirmation.vue";
import Footerpit from "../../components/FooterPIT.vue";

import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";

const genkeys = require("rezauthlib");
//import Swal from "sweetalert2";

import { reactive } from "vue";
const crypto = require("crypto");
import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

import useVuelidate from "@vuelidate/core";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  alpha,
} from "@vuelidate/validators";

import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    HeaderConfim,
    Footer,
    Footernwi,
    ConfirmationBanner,
    BasketItem,
    Cookies,
    CookiesOld,
    Footerpit
    // ResultsList,
    // ResultsGrid,
    // SearchWidget,
  },
  data() {
    return {
      styles_loaded: false,
      lang: "en",
      createaccount: "N",
      translations: "",
      v$: useVuelidate(),
      email: "",
      cartloaded: false,
      cartmessage: false,
      email_confirm: "",
      title: "",
      firstname: "",
      surname: "",
      phonecode: "",
      mobilenumber: "",
      country: "",
      showaddressfields: false,
      address: "",
      address_line_2: "",
      town: "",
      state: "",
      postcode: "",
      billingaddress_api: [],
      vehicle_vrn: "",
      info_block_vrn: false,
      outboundFlight: "",
      inboundFlight: "",
      info_block_flight_number: false,
      term_condition: false,
      email_consent: false,
      demo: "",
      date1_date: "",
      date1_time: "",
      date2_date: "",
      date2_time: "",
      searchres: [],
      carparkdetails: [],
      dataloaded: false,
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "Official airport parking",
      results_subheadline: "11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      orderreference: "",
      final_amount_paid: 0,
      final_amount_paid_tot: 0,
      is_guest: "",
      uuid_guest: "",
      guesttomember: "",
      setbrandid: "",
      currency: "",
      lounge_cartitem: "",
      fasttrack_cartitem: "",
      cartitem: "",

      privacy_policy_link: "",
      faqs_link: "",
      my_account_link: "",
      terms_and_conditions_link: "",
      showcart: false,
      qr_data_names: [],
      qr_product_name: "",
      qr_date: "",
      qr_time: "",
      ordercomplete: false,
      logKey:'',
    };
  },
  validations() {
    return {
      emailid: { required, email },
      // title: { required },
      firstname: { required, alpha, minLength: minLength(2) },
      surname: { required, alpha, minLength: minLength(2) },
      Email: { required, email },
      EmailConfirm: { required, email },
      phonecode: { required },
      state: { required },
      mobilenumber: {
        required,
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(15),
      },
      address: { required },
      postcode: { required },
      town: { required },
      country: { required },
      vehicle_vrn: { required },
      term_condition: {
        required(val) {
          return val;
        },
      },
    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles, "yourdetails");
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    currency_formatter(money) {
      if (!money) return;
      const arrayString = process.env.VUE_APP_CURRENCY_AFTER_VALUE;
      const array = JSON.parse(arrayString);
      if (array.includes(this.setbrandid)) {
        money = money.toString().replace(".", ",");
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },
    createaccountaction() {

      let chdata =
        encryptStorage.getItem("rez_dev_k").VUE_APP_CHL +
        this.setbrandid +
        encryptStorage.getItem("order_ref") +
        encryptStorage.getItem("final_uuid") +
        encryptStorage.getItem("tag_email");
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");
      let pspdata = {
        uuid: encryptStorage.getItem("final_uuid"),
        brand_id: this.setbrandid,
        order_ref: encryptStorage.getItem("final_orderreference"),
        email: encryptStorage.getItem("tag_email"),
        transaction_token: transaction_token,
      };

      let secsaa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_PAY_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_PAY_SECRETKEY
      );
      let b1sa = secsaa.b1s;
      let v2sa = secsaa.v2s;
      let a1a = secsaa.a1;
      let v1a = secsaa.v1;
      let c2sa = secsaa.c2s;
      let uidgena = secsaa.uidgen;
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/parkingamend_live/guesttomem.php",
          pspdata,
          {
            headers: {
              b1: b1sa,
              v2: v2sa,
              c2s: c2sa,
              a1: a1a,
              v1: v1a,
              c1: uidgena,
            },
          }
        )
        .then(
          (response) => {
            let datasent = JSON.parse(response.request.response);
            this.demo = datasent;
            encryptStorage.setItem("is_guest", "N");
            encryptStorage.setItem("guesttomember", "Y");
            this.createaccount = "Y";
          },
          (error) => {
            this.loading_proceed = false;
            console.log(error);
          }
        );
    },
    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        if (
          process.env.VUE_APP_DEFAULT_LANG_DE &&
          JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(
            this.setbrandid
          )
        ) {
          vm.lang = "de";
        }
        vm.setSessionData("language", vm.lang);
      }

      // console.log(vm.getSessionData("language"));
      //console.log("vm.lang");

      //console.log(this.lang);

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          //console.log("getTranscache");
          //console.log(vm.translations);
        } else {
          axios
            .get(
              "https://devhub.rezcomm.com/hubapmydbauth/brandapi/devtrans.php?brandslug=" +
                vm.setbrandid
            )
            .then((response) => {
              //console.log("getTranscache");
              // console.log(response);
              vm.translations = JSON.parse(response.request.response);
              store.setItem("tranlations", JSON.stringify(vm.translations));
            });
        }
      });
    },

    formatDatedmy(date) {
      date = date.split("/");
      date = date[2] + "/" + date[1] + "/" + date[0];
      return date;
    },
    populateaddress(event) {
      let optionText = event.target.value;
      let postcode_search_ar = optionText.split("~");
      this.address = postcode_search_ar[0];
      this.address_line_2 = postcode_search_ar[1];
      this.town = postcode_search_ar[2];
      this.state = postcode_search_ar[3];
      this.showaddressfields = true;
      this.billingaddress_api = "";
    },
    selectcountry() {
      let coun = this.country;
      if (coun != "GB" && coun != "") {
        this.showaddressfields = true;
      } else {
        this.showaddressfields = false;
      }
    },
    findyouraddress() {},
    upperCaseVRN(newValue) {
      this.vrn_number = newValue.toUpperCase();
    },
    lowerCaseEmail(newValue) {
      this.email = newValue.toLowerCase();
    },
    lowerCaseEmail_Confirm(newValue) {
      this.email_confirm = newValue.toLowerCase();
    },
    setListStyle(type) {
      this.result_selected_style = type;
    },
    setListOrder(type) {
      this.result_selected_order = type;
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      // console.log('this.brand_data.brand_product_styles', this.brand_data.brand_product_styles);
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;

      if (this.setbrandid === "YHM") {
        if (this.lang.toLowerCase() === "en") {
          this.privacy_policy_link = "https://flyhamilton.ca/privacy-policy/";
          this.faqs_link = "https://flyhamilton.ca/parking-faq/";
          this.my_account_link = "https://accounts.flyhamilton.ca/";
          this.terms_and_conditions_link = "/terms.html";
        }
      }

      if (this.setbrandid === "NQY") {
        this.privacy_policy_link =
          "https://www.cornwallairportnewquay.com/privacy-policy";
        this.faqs_link = "https://www.cornwallairportnewquay.com/help-desk/";
        this.my_account_link =
          "https://accounts.prebooking-newquaycornwallairport.com/";
        this.terms_and_conditions_link =
          "https://www.cornwallairportnewquay.com/download-centre/";
      }

      if (this.setbrandid === "SV1") {
        this.privacy_policy_link =
          "https://www.summitairportparking.com/privacy";
        this.faqs_link = "https://www.summitairportparking.com/faq";
        this.my_account_link = "https://myaccount.summitairportparking.com/";
        this.terms_and_conditions_link =
          "https://www.summitairportparking.com/terms";
      }

      if (this.setbrandid === "RDU") {
        if (this.lang === "en") {
          this.privacy_policy_link = "https://www.rdu.com/privacy/";
          this.faqs_link = "https://www.rdu.com/parking/parking-faq/";
          this.my_account_link = "https://accounts.rdu.com/";
          this.terms_and_conditions_link = "https://booking.rdu.com/terms.html";
        }
      }

      if (this.setbrandid === "HER") {
        if (this.lang.toLowerCase() === "en") {
          this.privacy_policy_link =
            "https://www.hermesairports.com/privacy-notice";
          this.faqs_link =
            "https://www.hermesairports.com/prepare-your-journey/fly-out/access--parking/assistance";
          this.my_account_link = "https://myaccount.hermesairports.com/";
          this.terms_and_conditions_link =
            "https://www.hermesairports.com/terms-and-conditions-of-use";
        } else if (this.lang.toLowerCase() === "el") {
          this.privacy_policy_link =
            "https://el.hermesairports.com/privacy-notice";
          this.faqs_link =
            "https://www.hermesairports.com/prepare-your-journey/fly-out/access--parking/assistance";
          this.my_account_link = "https://myaccount.hermesairports.com/";
          this.terms_and_conditions_link =
            "https://el.hermesairports.com/terms-and-conditions-of-use";
        }
      }

      if (this.setbrandid === "NWI") {
        if (this.lang === "en") {
          this.privacy_policy_link =
            "https://www.norwichairport.co.uk/privacy-policy/";
          this.faqs_link = "https://www.norwichairport.co.uk/car-parking/";
          this.my_account_link =
            "https://myaccount.prebook-norwichairport.com/";
          this.terms_and_conditions_link =
            "https://www.norwichairport.co.uk/terms-of-use/";
        }
      }

      if (this.setbrandid === "NOC") {
        this.privacy_policy_link = "https://www.irelandwestairport.com/privacy";
        this.faqs_link = "/faqs.html";
        this.my_account_link =
          "https://accounts.prebook-irelandwestairport.com/?lang=EN";
        this.terms_and_conditions_link =
          "https://www.irelandwestairport.com/car_parking/car-park-terms-and-conditions";
      }

      if (this.setbrandid === "INV") {
        this.privacy_policy_link =
          "https://www.hial.co.uk/downloads/file/936/hial-privacy-notice-data-collection-through-our-websites";
        this.faqs_link =
          "https://www.hial.co.uk/downloads/file/715/inverness-airport-car-parking-faqs";
        this.my_account_link =
          "https://accounts.prebook-invernessairport.co.uk/";
        this.terms_and_conditions_link =
          "https://www.hial.co.uk/downloads/file/714/terms-and-conditions";
      }

      if (this.setbrandid === "LDY") {
        this.privacy_policy_link =
          "https://www.cityofderryairport.com/privacy-policy/";
        this.faqs_link = "https://www.cityofderryairport.com/car-parking-info/";
        this.my_account_link =
          "https://accounts.prebook-cityofderryairport.com";
        this.terms_and_conditions_link =
          "https://www.cityofderryairport.com/car-parking-info/car-park-terms-and-conditions/";
      }

      if (this.setbrandid === "PV1") {
        this.privacy_policy_link = "https://pvdairpark.com/privacy";
        this.faqs_link = "https://pvdairpark.com/#faq";
        this.my_account_link = "https://myaccount.pvdairpark.com";
        this.terms_and_conditions_link = "https://pvdairpark.com/terms";
      }

      if (this.setbrandid === "LDY") {
        this.privacy_policy_link =
          "https://www.cityofderryairport.com/privacy-policy/";
        this.faqs_link = "https://prebook-cityofderryairport.com/faqs.html";
        this.my_account_link =
          "https://accounts.prebook-cityofderryairport.com/index.html";
        this.terms_and_conditions_link =
          "https://www.cityofderryairport.com/car-parking-info/car-park-terms-and-conditions/";
      }

      if (this.setbrandid === "RSW") {
        this.privacy_policy_link = "https://rswremoteparking.com/privacy.html";
        this.faqs_link = "https://rswremoteparking.com/faqs.html";
        this.my_account_link = "https://accounts.rswremoteparking.com";
        this.terms_and_conditions_link =
          "https://rswremoteparking.com/terms.html";
      }

      if (this.setbrandid === "HVN") {
        this.privacy_policy_link = "https://parkhvn.com/privacy";
        this.faqs_link = "https://parkhvn.com/faq/";
        this.my_account_link = "https://accounts.parkhvn.com/";
        this.terms_and_conditions_link = "https://parkhvn.com/terms";
      }
      if (this.setbrandid === "DRW") {
        this.privacy_policy_link =
          "https://www.darwinairport.com.au/privacy-statement";
        this.faqs_link =
          "https://www.darwinairport.com.au/traveller/parking-transport/parking/faq";
        this.my_account_link =
          "https://accounts.darwinairport.com.au/";
        this.terms_and_conditions_link =
          "https://www.darwinairport.com.au/online-booking-terms";
      }
      if (this.setbrandid === "JER") {
        this.privacy_policy_link =
          "https://www.jerseyairport.com/privacynotice";
        this.faqs_link =
          "https://www.jerseyairport.com/parking/long-stay/";
        this.my_account_link = "https://myaccount.jerseyairport.com";
        this.terms_and_conditions_link =
          "https://www.jerseyairport.com/terms-and-conditions";
      }
      if (this.setbrandid === "PIT") {
        this.privacy_policy_link = "https://flypittsburgh.com/privacy-policy";
        this.faqs_link =
          "https://res.cloudinary.com/rezcomm2018/image/upload/v1728907182/brands/PIT/PIT-Parking-Frequently-Asked-Questions-051624.pdf";
        this.my_account_link = "https://myparking.flypittsburgh.com";
        this.terms_and_conditions_link =
          "https://res.cloudinary.com/rezcomm2018/image/upload/v1729585942/brands/PIT/PIT_Parking_Information_October_2024_v3.pdf";
      }
      if (this.setbrandid === "ML1") {
        this.privacy_policy_link =
          "https://www.mdlmarinas.co.uk/_assets/mdl-privacy-policy-2024.pdf";
        this.faqs_link =
          "https://res.cloudinary.com/rezcomm2018/image/upload/v1730370401/brands/ML1/Ocean_Way_Car_Park_FAQ_MDL.pdf";
        this.my_account_link = "https://myaccount.mdlmarinas.co.uk/";
        this.terms_and_conditions_link =
          "https://www.mdlmarinas.co.uk/_assets/mdl-car-parking-terms.pdf";
      }
      if (this.setbrandid === "LAX") {
        this.privacy_policy_link = "https://www.flylax.com/legal";
        this.faqs_link = "https://www.flylax.com/parking-at-lax";
        this.my_account_link = "https://myparking.flylax.com";
        this.terms_and_conditions_link =
          "https://parking.flylax.com/lax-terms-and-conditions.html";
      }

      if (this.setbrandid === "PB1") {
        this.privacy_policy_link = "https://pbw.de/?menu=rechtliches";
        this.faqs_link = "https://www.pbw.de/services";
        this.my_account_link = "https://myspace.pbw.de/?lang=DE";
        this.terms_and_conditions_link = "https://pbw.de/?menu=rechtliches";
      }

      if (this.setbrandid === "FMM") {
        this.privacy_policy_link = "https://www.memmingen-airport.de/datenschutz/";
        this.faqs_link = "https://www.memmingen-airport.de/faqs/";
        this.my_account_link = "http://accounts.booking-memmingen-airport.de/?lang=DE";
        this.terms_and_conditions_link = "https://www.memmingen-airport.de/agb-parken/";
      }

      if (this.setbrandid === "SZG") {
        this.privacy_policy_link= "https://www.salzburg-airport.com/footer/legal/datenschutz",
        this.faqs_link= "https://shop.salzburg-airport.com/faqs.html",
        this.my_account_link= "https://managemybooking.salzburg-airport.com/",
        this.terms_and_conditions_link= "https://www.salzburg-airport.com/parken/allgemeine-geschaeftsbedingungen-online-parken"
      }
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        // console.log("uidgen", uidgen);

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/brandapi/branddetailslive.php?brandslug=" +
              this.setbrandid,
            "",
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            //console.log(response.data);
            this.setLocalData("brand_data", response.data);
            this.setMenu(response.data);
            this.createPanels(response.data);
            this.setBrandData();
            this.getorderdetails();
          });
      }
    },
    setStyles(obj) {
      /* eslint-disable */
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      // console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      // if (!Array.isArray(data.brand_menu) || !data.brand_menu.length > 0)
      //   return;
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    gotoPage(url) {
      window.location.href = url;
    },
    gotoPagenewtab(url) {
      let logKey;
      let mmb_link = encryptStorage.getItem("mmb_link");

      if (mmb_link && url.indexOf(mmb_link) > -1) {
        console.log("enw_log_key", logKey);
        logKey = encryptStorage.getItem("enw_log_key");
      }

      if (location.host == 'book.flylax.com' && url.indexOf('myparking.flylax.com') > -1) {
        logKey = encryptStorage.getItem("enw_log_key");
        url = 'https://myparking.flylax.com/';
      }

      // Append mmb_link as a query parameter
      if (logKey) {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set("log_key", logKey);
        url = urlObj.toString();
      }

      // Append lang if needed
      if (
        (url.indexOf("myaccountdev.") > -1 || url.indexOf("myaccount.") > -1) &&
        this.lang
      ) {
        const urlObj = new URL(url);
        urlObj.searchParams.set("lang", this.lang);
        url = urlObj.toString();
      }

      window.open(url, "_blank");
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      d = d.replace("st", "");
      d = d.replace("nd", "");
      d = d.replace("rd", "");
      d = d.replace("th", "");
      return d;
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },
    sendemailfailure() {
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_EMF_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_EMF_SECRETKEY
      );
      let b1s = secsa.b1s;
      let v2s = secsa.v2s;
      let a1 = secsa.a1;
      let v1 = secsa.v1;
      let c2s = secsa.c2s;
      let uidgen = secsa.uidgen;

      let data = {
        cartitem: this.cartitem,
        brand_id: this.setbrandid,
        booking_ref_id: this.getLocalData("order_ref"),
        email: this.getLocalData("tag_email"),
      };
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/sqsregister/parkingfailtobook.php",
          data,
          {
            headers: {
              b1: b1s,
              v2: v2s,
              c2s: c2s,
              a1: a1,
              v1: v1,
              c1: uidgen,
              "Content-Type": "application/json",
            },
          }
        )
        .then(
          (response) => {
            //sessionStorage.clear();
            console.log(response);
          },
          (error) => {
            //sessionStorage.clear();
            console.log(error);
          }
        );
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/gtbrnslg.php",
          "",
          {
            headers: {
              secret_id:
                encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key:
                encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          //console.log(response.data.slug);
          //console.log(response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.currency = response.data.currency;
            if (
              response.data.slug == "HER" ||
              response.data.slug == "NOC" ||
              response.data.slug == "SZG" ||
              response.data.slug == "FM1" ||
              response.data.slug == "FMM" ||
              response.data.slug == "PB1" ||
              response.data.slug == "BRE"
            ) {
              this.currency = "€";
            }
            if (response.data.slug == "RDU") {
              this.utmdata();
            }
            
            if (response.data.slug == "LAX") {
              this.enw_log();
            }
            this.loadTranslations();
            this.getBrandData();
            this.sendToDataLayer();
            this.clearConfirmationStorage();
          }
        });
    },
    clearConfirmationStorage() {
      if (typeof encryptStorage.getItem("fasttrack_cart_coach") === "undefined") {
        if (window.location.hostname !== "localhost") {
          encryptStorage.removeItem("session_pay");
          sessionStorage.removeItem("cart");
          sessionStorage.removeItem("fasttrack_cart");
          sessionStorage.removeItem("lounge_cart");
          sessionStorage.removeItem("orefwithoutprefix");
          encryptStorage.removeItem("cart");
          encryptStorage.removeItem("oldcart");
          encryptStorage.removeItem("tag_totcost");
          encryptStorage.removeItem("fasttrack_cart");
          encryptStorage.removeItem("fasttrack_cart_coach");
          encryptStorage.removeItem("final_orderreference");
          encryptStorage.removeItem("lounge_cart");
          encryptStorage.removeItem("orefwithoutprefix");
          encryptStorage.removeItem("order_ref");
          encryptStorage.removeItem("dis_cpk");
          encryptStorage.removeItem("dis_lng");
          encryptStorage.removeItem("dis_ftt");
          encryptStorage.removeItem("discount_amount");
          encryptStorage.removeItem("discount_amount_applied");
          encryptStorage.removeItem("discount_coupon_applied");
          encryptStorage.removeItem("final_amount_paid");
          encryptStorage.removeItem("orderplaced");
          encryptStorage.removeItem("crosssell_fttshown");
          encryptStorage.removeItem("finaltotalvalue_lng");
          encryptStorage.removeItem("finaltotalvalue_ftt");
          encryptStorage.removeItem("finaltotalvalue_cpk");
          encryptStorage.removeItem("crosssell_lngshown");
        }
      }
    },
    getLocalDataoo(name) {
      return sessionStorage.getItem(name);
    },
    usDBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_USD);
      } catch (e) {
        console.error("Failed to parse VUE_APP_USD:", e);
        return [];
      }
    },
    gbPBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_GBP);
      } catch (e) {
        console.error("Failed to parse VUE_APP_GBP:", e);
        return [];
      }
    },
    euRBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_EUR);
      } catch (e) {
        console.error("Failed to parse VUE_APP_EUR:", e);
        return [];
      }
    },
    gaGtmBrands() {
      try {
        return JSON.parse(process.env.VUE_APP_GTM);
      } catch (e) {
        console.error("Failed to parse VUE_APP_GTM:", e);
        return [];
      }
    },
    sendToDataLayer() {
      if (this.setbrandid === "NWI") {
        console.log("sendToDataLayer", this.fasttrack_cartitem);
        let coupon = "";
        let discount_price = "";
        if (typeof encryptStorage.getItem("discount_amount") === "undefined") {
          //do nothing
        } else {
          coupon = encryptStorage.getItem("discount_coupon_applied");
          discount_price = encryptStorage.getItem("discount_amount");
        }
        console.log("discount_price", discount_price);
        let items = [];
        let parking_obj = {};
        let lounge_obj = {};

        if (this.cartitem !== undefined) {
          console.log("sendToDataLayer cpk", this.cartitem);
          parking_obj.item_id = this.cartitem.product_id;
          parking_obj.item_name = this.cartitem.product_name;
          parking_obj.item_category = "Parking";
          parking_obj.price = this.cartitem.price;
          parking_obj.quantity = 1;
          items.push(parking_obj);
        }

        if (this.lounge_cartitem !== undefined) {
          console.log("sendToDataLayer lng", this.lounge_cartitem);
          lounge_obj.item_id = this.lounge_cartitem.lounge_id;
          lounge_obj.item_name = this.lounge_cartitem.product_name;
          lounge_obj.item_category = "Lounge";
          lounge_obj.price = this.lounge_cartitem.loungesubtotal;
          lounge_obj.quantity =
            Number(this.lounge_cartitem.ADL) +
            Number(this.lounge_cartitem.CHD) +
            Number(this.lounge_cartitem.INF);
          items.push(lounge_obj);
        }

        console.log("items", items);
        // todo add tax promocode & ftt?

        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "purchase",
          ecommerce: {
            currency: "GBP",
            transaction_id: this.orderreference,
            value: this.final_amount_paid_tot, //total purchase amount including tax
            tax: "", //value of tax on purchase
            coupon: coupon, //if a promo code has been used for the purchase, include it here. If not, leave blank
            items: items,
          },
        });

        console.log("datalayer", dataLayer);
        /* eslint-enable */
      }

      if (this.gaGtmBrands().indexOf(this.setbrandid) > -1) {
        let items = [];
        let parking_obj = {};
        let datalayerparams = encryptStorage.getItem("datalayerparams");
        let datalayerEcomItems =
          datalayerparams &&
          datalayerparams.ecommerce &&
          Array.isArray(datalayerparams.ecommerce.items) &&
          datalayerparams.ecommerce.items.length > 0
            ? datalayerparams.ecommerce.items
            : [];
        let firstDataLayerItem =
          datalayerEcomItems.length > 0 ? datalayerEcomItems[0] : null;
        let entry_date = "";
        let entry_time = "";
        let exit_date = "";
        let exit_time = "";
        if (this.cartitem !== undefined) {
          entry_date = this.cartitem.valid_from;
          entry_time = this.cartitem.start_time;
          exit_date = this.cartitem.valid_till;
          exit_time = this.cartitem.end_time;
          entry_date = entry_date.replace("/", "-");
          entry_date = entry_date.replace("/", "-");
          exit_date = exit_date.replace("/", "-");
          exit_date = exit_date.replace("/", "-");
          console.log("sendToDataLayer cpk", this.cartitem);
          parking_obj.item_id = this.cartitem.product_id;
          parking_obj.item_name = this.cartitem.product_name;
          parking_obj.item_category = "Parking";
          parking_obj.price = this.final_amount_paid_tot;
          parking_obj.discount = firstDataLayerItem
            ? firstDataLayerItem.discount
            : "0.00";
          parking_obj.coupon = firstDataLayerItem ? firstDataLayerItem.coupon : "";
          parking_obj.quantity = 1;
          items.push(parking_obj);
        }

        if (datalayerEcomItems.length > 0) {
          items = datalayerEcomItems;
          console.log("items", items);
        }
        let ecommerce = {
          currency: "USD",
          transaction_id: this.orderreference,
          coupon: firstDataLayerItem ? firstDataLayerItem.coupon : "",
          value: this.final_amount_paid_tot,
          item_list_id: this.setbrandid.toLowerCase() + "_cpk_list",
          item_list_name:
            this.setbrandid.toUpperCase() + " Carpark Search Result List",
          items: items,
        };
        if (this.usDBrands().indexOf(this.setbrandid) > -1) {
          ecommerce.currency = "USD";
        }
        if (this.euRBrands().indexOf(this.setbrandid) > -1) {
          ecommerce.currency = "EUR";
        }
        if (this.gbPBrands().indexOf(this.setbrandid) > -1) {
          ecommerce.currency = "GBP";
        }
        if (this.setbrandid === "PV1") {
          ecommerce.send_to = "AW-16447517358/Wt3nCJX9vZcZEK7l5KI9";
        }
        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "purchase",
          entry_date: entry_date,
          exit_date: exit_date,
          entry_time: entry_time,
          exit_time: exit_time,
          ecommerce: ecommerce,
        });
        /* eslint-enable */

        if (this.setbrandid == "LAX") {
          const isTbScriptLoaded = typeof Tinybird !== "undefined";
          let userdata = encryptStorage.getItem("newuser");
          let returning_customer = "No";
          if (userdata !== undefined) {
            if (userdata == "0") {
              returning_customer = "Yes";
            }
          }
          console.log("isTbScriptLoaded", isTbScriptLoaded);
          if (isTbScriptLoaded) {
            window.Tinybird.trackEvent("conversion", {
              brand_id: this.setbrandid,
              orderreference: "LAX-CPK-" + this.orderreference,
              returning_customer: returning_customer,
              ordertotal: this.final_amount_paid_tot,
            });
          }
        }
      }
    },

    gensessionid() {
      if (encryptStorage.getItem("search_analytics_id") === undefined) {
        let search_analytics_id = crypto.randomBytes(16).toString("base64");
        encryptStorage.setItem("search_analytics_id", search_analytics_id);
        return search_analytics_id;
      } else {
        return encryptStorage.getItem("search_analytics_id");
      }
    },
    utmdata() {
      let sessid = "";
      let analytics = "0";
      if (!this.$cookie.isCookieAvailable("session-id")) {
        this.gensessionid();
        sessid = encryptStorage.getItem("search_analytics_id");
      } else {
        sessid = this.$cookie.getCookie("session-id");
        analytics = "1";
      }
      if (this.$cookie.isCookieAvailable("utm_partner")) {
        let trackevents = {
          page: window.location.href,
          analytics: analytics,
          orderpaid: "1",
          orderreference: encryptStorage.getItem("orefwithoutprefix"),
          search_analytics_id: encryptStorage.getItem("search_analytics_id"),
        };
        let tdata = {
          utm_campaign: this.$cookie.getCookie("utm_campaign"),
          utm_content: this.$cookie.getCookie("utm_content"),
          utm_medium: this.$cookie.getCookie("utm_medium"),
          utm_partner: this.$cookie.getCookie("utm_partner"),
          utm_source: this.$cookie.getCookie("utm_source"),
          utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
          utm_term: this.$cookie.getCookie("utm_term"),
          session_id: sessid,
          trackevents: trackevents,
        };

        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_UTM_CAMPAIGN_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_UTM_CAMPAIGN_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;

        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/utm_campaign/camprdulive.php",
            tdata,
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log("utmdata", response.data);
          });
      }
    },
    getorderdetails() {
      console.log(
        "fasttrack_cart_coach",
        encryptStorage.getItem("fasttrack_cart_coach")
      );

      if (
        typeof encryptStorage.getItem("fasttrack_cart_coach") !== "undefined"
      ) {
        let datasearch = {
          uuid: this.getLocalData("uuid"),
          slug: this.setbrandid,
          orderreference: `HER-FTT-` + this.orderreference,
        };
        let secsa = genkeys(
          encryptStorage.getItem("rez_dev_k").VUE_APP_CUSTBOOKINGS_SECRETID,
          encryptStorage.getItem("rez_dev_k").VUE_APP_CUSTBOOKINGS_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;
        let th = this;
        axios
          .post(
            encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/sqsregister/livecustomerparkingbookings_frankfurt_live.php",
            datasearch,
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            let data = JSON.parse(response.request.response);
            //let refunds = [];
            //refunds = data.refunds;
            //this.cpms_reference = data.cpms_reference;
            this.orderdata = data.result[0];
            this.emailentered_order = this.orderdata.email;

            let cartdetails = "";

            try {
              cartdetails = JSON.parse(data.result[0].cart);
            } catch (err) {
              cartdetails = JSON.parse(JSON.stringify(data.result[0].cart));
            }
            if (cartdetails.date_selected === undefined) {
              cartdetails = JSON.parse(cartdetails);
            }
            console.log("cartdetails", cartdetails.date_selected);

            this.ekashu_transaction_id = "";
            console.log("this.orderdata", this.orderdata);

            console.log("response-------------------", response);

            this.qr_data_names = JSON.parse(response.data.refunds[0].names);
            let names = [];
            for (let b = 0; b < this.qr_data_names.length; b++) {
              let it = this.qr_data_names[b];
              let a = it.indexOf("Adult");
              let c = it.indexOf("Child");
              let i = it.indexOf("Infant");
              let j = b + 1;
              if (a >= 0) {
                names.push("Adult " + j);
              }
              if (c >= 0) {
                names.push("Child " + j);
              }
              if (i >= 0) {
                names.push("Infant " + j);
              }
            }
            this.qr_data_names = names;
            this.qr_data_qrcodes = response.data.refunds[0].qrcodes;
            console.log("this.qr_data_names", this.qr_data_names);
            console.log("this.qr_data_qrcodes", this.qr_data_qrcodes[0]);

            this.qr_image_src = response.data.refunds[0].qrurl;
            this.qrurlorig_image_src = response.data.refunds[0].qrurlorig;

            this.qr_date = cartdetails.date_selected
              .split("/")
              .reverse()
              .join("/");
            this.qr_time = cartdetails.time_selected;
            this.qr_product_name = cartdetails.product_name;
            if (
              this.qr_data_qrcodes[0] != "" &&
              this.qr_data_qrcodes.length === this.qr_data_names.length
            ) {
              this.ordercomplete = true;
              if (window.location.hostname !== "localhost") {
                encryptStorage.removeItem("session_pay");
                sessionStorage.removeItem("cart");
                sessionStorage.removeItem("fasttrack_cart");
                sessionStorage.removeItem("lounge_cart");
                sessionStorage.removeItem("orefwithoutprefix");
                encryptStorage.removeItem("cart");
                encryptStorage.removeItem("oldcart");
                encryptStorage.removeItem("tag_totcost");
                encryptStorage.removeItem("fasttrack_cart");
                encryptStorage.removeItem("fasttrack_cart_coach");
                encryptStorage.removeItem("final_orderreference");
                encryptStorage.removeItem("lounge_cart");
                encryptStorage.removeItem("orefwithoutprefix");
                encryptStorage.removeItem("order_ref");
                encryptStorage.removeItem("dis_cpk");
                encryptStorage.removeItem("dis_lng");
                encryptStorage.removeItem("dis_ftt");
                encryptStorage.removeItem("discount_amount");
                encryptStorage.removeItem("discount_amount_applied");
                encryptStorage.removeItem("discount_coupon_applied");
                encryptStorage.removeItem("final_amount_paid");
                encryptStorage.removeItem("orderplaced");
                encryptStorage.removeItem("crosssell_fttshown");
                encryptStorage.removeItem("finaltotalvalue_lng");
                encryptStorage.removeItem("finaltotalvalue_ftt");
                encryptStorage.removeItem("finaltotalvalue_cpk");
                encryptStorage.removeItem("crosssell_lngshown");
              }
            } else {
              let ab = th;
              setTimeout(function () {
                ab.getorderdetails();
              }, 2000);
            }
          });
      }
    },
    enw_log() {
      // Generate a transaction token using a secure hash
      let chdata =
        encryptStorage.getItem("rez_dev_k").VUE_APP_CHL +
        this.setbrandid.toLowerCase() +
        this.getLocalData("uuid");
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      // Create request data with timestamp for freshness
      let datasearch = {
        uuid: this.getLocalData("uuid"),
        brand_id: this.setbrandid.toLowerCase(),
        orderreference: this.orderreference,
        transaction_token: transaction_token,
        timestamp: Date.now(), // Add timestamp for request freshness
      };

      // Get authentication keys
      let secsa = genkeys(
        encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETID,
        encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDDET_SECRETKEY
      );

      // Add request ID for tracking and replay protection
      const requestId =
        Date.now().toString(36) + Math.random().toString(36).substr(2);

      // API endpoint
      let ur = "hubapmydbauth/live_alog/enw.php";

      // Make API request with security headers
      axios
        .post(encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB + ur, datasearch, {
          headers: {
            b1: secsa.b1s,
            v2: secsa.v2s,
            c2s: secsa.c2s,
            a1: secsa.a1,
            v1: secsa.v1,
            c1: secsa.uidgen,
            "Content-Type": "application/json",
            "X-Request-ID": requestId,
          },
        })
        .then((response) => {
          // Validate response
          if (!response || !response.data) {
            console.error("Invalid response from server");
            return;
          }

          let data = response.data;

          // Store token securely with expiration
          if (data.user_exists === "Y" && data.data) {
            encryptStorage.setItem("enw_log_key", data.data);
            encryptStorage.setItem("mmb_link", data.mmb_link);
            this.logKey = encryptStorage.getItem("enw_log_key");
            this.updateHeader += 1;
          }
        })
        .catch((error) => {
          console.error("Authentication error", error);
          // Don't log detailed error information
        });
    },    
  },
  created() {},
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById("loader");
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
    //this.setbrandid = "BOS";
    //this.currency = "$";
    this.getbranded();
    // console.log("window.location.hostname", window.location.hostname);
    // if (this.setbrandid == "") {
    //   this.setbrandid = "BOS";
    //   this.currency = "$";
    //   if (window.location.hostname == "herv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "HER";
    //     this.currency = "€";
    //   }
    //   if (window.location.hostname == "nwiv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "NWI";
    //     this.currency = "£";
    //   }
    //   if (window.location.hostname == "rduv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "RDU";
    //     this.currency = "$";
    //   }
    //   if (window.location.hostname == "bosv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "BOS";
    //     this.currency = "$";
    //   }
    // }
    this.cartitem = encryptStorage.getItem("cart");
    this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
    //console.log("fasttrack_cartitem", this.fasttrack_cartitem);
    this.lounge_cartitem = encryptStorage.getItem("lounge_cart");
    //console.log("lounge_cartitem", this.lounge_cartitem);
    this.orderreference = encryptStorage.getItem("orefwithoutprefix");
    this.is_guest = encryptStorage.getItem("is_guest");
    this.guesttomember = encryptStorage.getItem("guesttomember");
    this.final_amount_paid_tot = encryptStorage.getItem("final_amount_paid");

    console.log("final_amount_paid", this.final_amount_paid);
    this.cartloaded = true;
    if (typeof encryptStorage.getItem("discount_amount") !== "undefined") {
      console.log("aaaaaa");
      this.final_amount_paid = encryptStorage.getItem("final_amount_paid");
    } else {
      console.log("bbbbb");
      if (this.cartitem && this.cartitem.price) {
        this.final_amount_paid = this.cartitem.price;
      }
    }
    this.showcart = true;
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
@import "@/assets/sass/override_brand.scss";
.tab-basket {
  display: none !important;
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.confirmation-banner-container {
  height: 171px;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}

.page-content {
  // outline: 1px solid red;
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  // margin-top: -3.5rem;
  margin-top: 1rem;
  gap: 2rem;

  @media screen and (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  &--fullwidth {
    text-align: center;
    @media screen and (min-width: 960px) {
      grid-template-columns: 1fr;
      text-align: left;
    }
  }

  padding: 1rem;

  &__box {
    // outline: 1px solid green;

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #dfdfdf;
      padding: 1em 1.375rem;
      margin-bottom: 2rem;
      @media screen and (min-width: 960px) {
        padding: 1.5em 1.875rem;
      }
    }

    &--box-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

  &__box-details {
    padding: 1em 1rem 1rem 1.375rem;
    padding-right: calc(1rem - 20px);
  }

  &__box-ref {
    display: flex;
    justify-content: space-between;
    font-size: 1.25rem;
    border-top: 1px solid #55555555;
    border-bottom: 1px solid #55555555;
    padding: 1rem 0;
  }

  &__box-proceed {
    margin-bottom: 1rem;
    button {
      width: 100%;
      padding: 1em;
      background: #034a94;
      color: #fff;
      border: 0px;
      border-radius: 0.25rem;
    }
  }

  &__box-numbered {
    display: flex;
    justify-content: flex-start;
  }

  &__box-number {
    width: 3.5rem;
    height: 3.5rem;
    min-width: 3.5rem;
    min-height: 3.5rem;
    // display: flex;
    display: none;
    justify-content: center;
    align-items: center;
    border-radius: 3rem;
    margin-right: 1rem;
    background: var(--details_numbers_confirmation_background, #2474a6);
    color: var(--details_numbers_confirmation_font_color, #fff);
    border: var(--details_numbers_confirmation_border, none);
    font-family: var(--details_numbers_confirmation_font_family, inherit);
    font-size: var(--details_numbers_confirmation_font_size, 2rem);
    font-weight: var(--details_numbers_confirmation_font_weight, bold);
  }

  &__box-number-text {
    width: 100%;
  }

  &__box-btn {
    width: 100%;
    padding: 1em;
    background: var(--details_buttons_confirmation_background, #034a94);
    color: var(--details_buttons_confirmation_font_color, #fff);
    border: var(--details_buttons_confirmation_border, none);
    border-radius: var(--details_buttons_confirmation_border_radius, 0.25rem);
    font-family: var(--details_buttons_confirmation_font_family, inherit);
    font-size: var(--details_buttons_confirmation_font_size, 1rem);
    font-weight: var(--details_buttons_confirmation_font_weight, normal);
    @media screen and (min-width: 960px) {
      width: 50%;
    }
  }

  &__box-title {
    clear: both;
    padding: 0.25rem 0 1rem;
    font-family: var(--details_headings_font_family, inherit);
    font-size: var(--details_headings_font_size, 1.25rem);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #0a3b74);
  }

  &__basket-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.5rem;
    padding: 1.5rem 0 0.5rem;
    border-top: 1px solid #55555555;
  }

  &__box-title--total {
    font-size: 1.5rem;
  }

  &__box-title--price {
    font-size: 1.5rem;
    font-family: var(--basket_price_font_family, inherit);
    font-weight: var(--basket_price_font_weight, bold);
    color: var(--basket_price_font_color, #236ca3);
  }

  &__basket {
    // outline: 1px solid blue;
    display: none;
    @media screen and (min-width: 960px) {
      display: block;
    }

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #dfdfdf;
      padding: 1em 1.375rem;
      margin-bottom: 1rem;
    }
  }

  &__download-box {
    border: 2px solid #e5e4e9;
    margin-bottom: 1rem;
    border-radius: 0.5rem;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  &__download-box--active {
    border: 2px solid #236ca3;
  }

  &__download-body {
    h4 {
      font-size: 1rem;
      font-weight: bold;
    }
    p {
      font-size: 0.925rem;
      margin: 0;
    }
  }
}

.confirmation-image {
  height: 2.5rem;
  width: 2.5rem;
  display: block;
  margin-bottom: 1rem;
}

.underline {
  text-decoration-line: underline;
  cursor: pointer;
}

.account-created-box {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  border: 2px solid #039420;
  color: #039420;
  font-weight: bold;
  border-radius: 0.25rem;
  padding: 0.5rem 3rem;
  .confirmation-image {
    margin: 0 0.5rem 0 0;
    width: 2rem;
    height: 2rem;
  }
}
</style>
